import { useQuery } from "@tanstack/react-query";
import { getArtists, getArtistBySlug } from "@/lib/api";

interface UseArtistsOptions {
  status?: "open" | "closed" | "waitlist";
  tags?: string[];
  // Comma-separated content ratings (e.g., "safe" or "safe,suggestive")
  contentRating?: string;
  enabled?: boolean;
  includeClosedArtists?: boolean;
}

export function useArtists(options: UseArtistsOptions = {}) {
  const { enabled = true, includeClosedArtists = false, ...params } = options;

  return useQuery({
    queryKey: ["artists", params],
    queryFn: () => getArtists(params),
    enabled,
    select: (data) =>
      includeClosedArtists
        ? data.artists
        : data.artists.filter((artist) => artist.status !== "closed"),
  });
}

// contentRating: comma-separated string (e.g., "safe" or "safe,suggestive")
export function useArtist(slug: string, contentRating?: string) {
  return useQuery({
    queryKey: ["artist", slug, contentRating],
    queryFn: () => getArtistBySlug(slug, contentRating),
    enabled: !!slug,
    select: (data) => data.artists[0] ?? null,
  });
}
